<label for="exampleFormControlInput1" class="form-label">Employee ID <sup *ngIf="isMandatory">*</sup></label>
<input
  type="text"
  placeholder="Search Employee"
  [formControl]="employeeFormControl"
  (ngModelChange)="handleInputChange($event)"
  (keypress)="disableSpecialChars($event)"
  [matAutocomplete]="auto"
  class="query-name-input form-select-without-bg-img"
  [ngClass]="{ 'is-invalid': isMandatory && employeeFormControl.errors && employeeFormControl.touched }" />
<mat-autocomplete
  #auto="matAutocomplete"
  [displayWith]="displayFn.bind(this)"
  [ngClass]="{ 'is-invalid': isMandatory && employeeFormControl.errors && employeeFormControl.touched }"
  (optionSelected)="onSelect($event.option.value)">
  <mat-option *ngFor="let employee of employees" [value]="employee?.id">
    {{ employee?.employeeCode }} - {{ employee?.firstName }} {{ employee?.middleName || '' }}
    {{ employee?.lastName || '' }}
  </mat-option>
</mat-autocomplete>

<mat-error>
  <div *ngIf="isMandatory && employeeFormControl && employeeFormControl.errors && employeeFormControl.touched">
    <div *ngIf="employeeFormControl.errors.required">This is mandatory, Kindly select Employee</div>
  </div>
</mat-error>
